import customeAxios from "../utils/axios";
import axios from "axios";
const API_BASE_URL = process.env.REACT_APP_API_URL;

export const AuthService = {
  login: async ({ email, password, role }) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/auth/login`,
        {
          email,
          password,
          role,
        },
        { withCredentials: true }
      );

      if (response?.status === 200) {
        return true;
      } else {
        throw new Error("Login failed.");
      }
    } catch (error) {
      console.log(error);
      throw new Error(error?.response?.data?.message || "Failed to login");
    }
  },

  verifyOtp: async ({ email, otp }) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/auth/verifyOtpLogin`,
        { email, otp },
        {
          withCredentials: true,
        }
      );

      if (response?.status === 200) {
        return response?.data?.user;
      } else {
        throw new Error("Failed to verify otp");
      }
    } catch (error) {
      throw new Error(error?.response?.data?.message || "Failed to verify otp");
    }
  },
  logOut: async () => {
    try {
      const response = await customeAxios.post("/api/auth/logout");
      if (response.data.success) {
        return true;
      }
    } catch (error) {
      throw new Error(error?.response?.data?.message || "Failed to logout");
    }
  },

  clientLogin: async ({ email, password, role }) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/auth/clientLogin`,
        { email, password, role },
        { withCredentials: true }
      );

      if (response?.status === 200) {
        return true;
      }
    } catch (error) {
      throw new Error(error?.response?.data?.message || "Failed to login");
    }
  },
  verifyClientOtp: async ({ email, otp }) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/auth/verifyOtpClientLogin`,
        { email, otp },
        {
          withCredentials: true,
        }
      );

      if (response?.status === 200) {
        return response?.data?.client;
      } else {
        throw new Error("Failed to verify otp");
      }
    } catch (error) {
      throw new Error(error?.response?.data?.message || "Failed to verify otp");
    }
  },

  getUser: async () => {
    try {
      const response = await customeAxios.get("/api/auth/getUser", {
        withCredentials: true,
      });
      if (response?.status === 200) {
        return response?.data?.data;
      } else {
        throw new Error("Failed to get user");
      }
    } catch (error) {
      throw new Error(error?.response?.data?.message || "Failed to get user");
    }
  },

  changePassword: async (formData) => {
    try {
      const response = await customeAxios.post(
        "/api/auth/change-password",
        formData,
        {
          withCredentials: true,
        }
      );
      if (response?.status === 200) {
        return response.data;
      }
    } catch (error) {
      throw new Error(
        error?.response?.data?.message || "Failed to change password"
      );
    }
  },

  resendOtp: async ({ email, role }) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/auth/resendOtp`,
        {
          email,
          role,
        },
        {
          withCredentials: true,
        }
      );

      if (response?.status === 200) {
        return response.data;
      }
    } catch (error) {
      throw new Error(error?.response?.data?.message || "Failed to resend otp");
    }
  },

  getEmployeeList : async () => {
    try {
      const response = await customeAxios.get("/api/auth/employees");
      if (response?.status === 200) {
        return response?.data?.data;
      }
    } catch (error) {
      throw new Error(error?.response?.data?.message || "Failed to get employee list");
    }
  },
};
